import { useState } from 'react';
import { AdminContactChanges } from './ContactChanges';
import { AdminAuditLogs } from './AuditLogs';

type Tab = 'contact-changes' | 'view-audit';

export const AdminAudit = () => {
  const [tab, setTab] = useState<Tab>('contact-changes');
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Audit</h1>
        <p className="text-sm text-gray-600">Select a section to review contact changes or contact view history.</p>
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => setTab('contact-changes')}
          className={`rounded px-4 py-2 text-sm font-medium ${tab === 'contact-changes' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
        >
          Contact Changes
        </button>
        <button
          type="button"
          onClick={() => setTab('view-audit')}
          className={`rounded px-4 py-2 text-sm font-medium ${tab === 'view-audit' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
        >
          Contact View Audit
        </button>
      </div>
      {tab === 'contact-changes' ? <AdminContactChanges /> : <AdminAuditLogs />}
    </div>
  );
};
